<div class="d-flex justify-space-between">
    <div>
        <img alt="back" class="cursor" (click)="handleBack()" src="../../../../assets/images/arrow_circle_left.svg" />&nbsp; <span class="geo-title">Geo Trace - Playback History</span>
    </div>
    <div class="d-flex mb5">
    <div class="media-player">
    
      <!-- Controls -->
      <div class="controls">
        <!-- Rewind Button -->
        <div (click)="rewind()">
          <img alt="rewind" src="../../../../assets/images/fast_rewind.svg" />
        </div>
    
        <!-- Play/Pause Button -->
        <div  (click)="!isRunning && (index < totalSteps)? startInterval() : pause()" class="cursor">
          <img alt="rewind" src="../../../../assets/images/Play-data.svg" *ngIf="!isRunning" />
          <img alt="rewind" src="../../../../assets/images/Pause-Icon.svg" *ngIf="isRunning"/>
        </div>
    
        <!-- Forward Button -->
        <div  (click)="fastForward()">
          <img alt="rewind" src="../../../../assets/images/fast_forward.svg" />
        </div>
    
        <!-- Progress Slider -->
        <div class="slider-container">
          <!-- Current Time (Left) -->
          <span class="time-duration">{{ formatTime(index) }}</span>
          &nbsp;
          <!-- Playback Slider -->
          <input
            type="range"
            class="slider"
            min="0"
            [max]="totalSteps"
            [value]="index"
            (input)="onSliderChange($event)"
            class="w-240"
          />
          &nbsp;
          <!-- Total Duration (Right) -->
          <span class="time-duration">{{ formatTime(totalSteps) }}</span>
        </div>
        <div>
          <img alt="rewind" src="../../../../assets/images/play-settings.svg" />
        </div>
      </div>
    </div>
    
    </div>

</div>
<div class="dashboard-container">
  <div>
<div class="last-row mb-10">
    <div class="left-boxes">
      <app-trip-history  [entityId]="entityId" [date]="selectedDate" [aggregateDate]="aggregateDate" [pageType]="'geoPlayback'" [isCollapsed]="isCollapsed" [entityName]="entityDetails?.uniqueId" [tripName]="tripName" (tripDetailsRequest)="handleTileDetail($event)"></app-trip-history>
      <div class="box map-box d-grid position-relative">
        
        <!-- Map Content -->
        <div *ngIf="isloader" class="h-100 w-100 padt-5">
          <mat-progress-bar [mode]="'indeterminate'">
          </mat-progress-bar>
        </div>
        <img src="../../../../assets/images/general-ai-button.svg" alt="ai" 
              *ngIf="sharedService.rbacManagement('vehicles_Enrolled_PrescriptiveInsights') && entityDetails?.enablePrescriptiveInsights && tripInsightsData?.length"
              class="h-36 position-absolute cursor"
              style="top: 12px; right: 57px; z-index: 9999;" (click)="getTrips()">
        <img src="../../../../assets/images/collaps-geotrace.svg" 
              *ngIf="!isloader && masterMapData?.length && !isCollapsed"
               class="position-absolute cursor" 
               alt="expand" 
               style="top: 10px; right: 10px; z-index: 9999;" (click)="expandMap()" />
        <img src="../../../../assets/images/collapse-geotrace.svg" 
              *ngIf="!isloader && masterMapData?.length && isCollapsed"
               class="position-absolute cursor" 
               alt="expand" 
               style="top: 10px; right: 10px; z-index: 9999;" (click)="expandMap()" />
        <app-leaflet-map pageType="profile" [mapData]="masterMapData" [isPlaying]="isRunning" [isPaused]="isPaused" [styleType]="'geotrace'" [showAiAssist]="showAiAssist" [tripAssistPlots]="tripAssistPlots"></app-leaflet-map>
      </div>
     
    </div>


    <div class="r-containers-info">
      <div class="info-header">
        <div class="info-item" *ngFor="let alert of alertTypes">
          <div>
            <img 
              [src]="derivedAlerts[alert.key] ? 
                '../../../../assets/images/Derived-active-alert.svg' : 
                '../../../../assets/images/Alert-playback.svg'" 
              alt="alert"
            />
          </div>
          <div>{{ alert.displayName }}</div>
        </div>
      </div>
      <div class="table-container">
        <div class="table-header">
            <h2 class="table-title">Telemetry Trails</h2>
        </div>
        <div *ngIf="isloader" class="h-100 w-100 padt-5">
          <mat-progress-bar [mode]="'indeterminate'">
          </mat-progress-bar>
        </div>
        <app-common-table [columnHeader]="telemetryColumHeader" [tableData]="telemetryTableData" [tableTitle]="'Telemetry Data'" pageType="geoTraceTelemetry"
        [actionPermission]="{pagination : false}"></app-common-table>
      </div>
    </div>
  </div>








  <div class="last-row">
      <div class="box chart-box">
        <div class="chart-type-dropdown">
          <mat-form-field appearance="outline" class="byc-dropdown-chart">
              <mat-select 
                [formControl]="chartType" 
                panelClass="multiSelectPanel" 
                placeholder="Chart Type" 
                class="-mat-select-mt-0"
                (selectionChange)="onChartTypeChange($event)"
              >
                <mat-option *ngFor="let item of chartTypes" [value]="item?.value">
                  {{ item.name | titlecase }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            
        </div>
        <!-- Chart Content -->
        <app-chart-builder [entityDetails]="{_id: entityId}" class="h-100" [hideStatistics]="true" [selfServiceChartAttributes]="chartAttributes"></app-chart-builder>
      </div>
    

  
    

      <div class="table-container w-100">
        <div class="table-header">
            <h2 class="table-title">Alerts</h2>
        </div>
        <div class="table-wrapper">
            <app-common-table [columnHeader]="alertColumnHeader" [tableData]="alertsHighlighted" [tableTitle]="'Alerts'" pageType="geoTraceAlert" (selectedAlert)="selectedAlert($event)" [hasStickyHeader]="true"
            [actionPermission]="{pagination : false}"></app-common-table>
        </div>
      </div>
    </div>
  </div>
  <app-trip-drawer
  [isOpen]="isDrawerOpen"
  [tripData]="tripItems"
  [summaryData]="summaryData"
  [title]="drawerTitle"
  [entityDetails]="entityDetails"
  [subtitle]="drawerSubtitle"
  (closeDrawer)="closeDrawer()"
  (itemClick)="onTripItemClick($event)">
</app-trip-drawer>
</div>
